import { render, staticRenderFns } from "./QColorAlphaSlider.vue?vue&type=template&id=67531b53&"
import script from "./QColorAlphaSlider.vue?vue&type=script&lang=js&"
export * from "./QColorAlphaSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports